import { put } from "redux-saga/effects";
import { ApiCaller, Utils } from "../../config";
import { InterviewsAction } from "../actions";

export default class InterviewsMiddleware {
  static *GetInterviewsListing({ payload, cb }) {
    try {
      const { limit = 10, page = 1, type = "all", status = "" } = payload;
      let res = yield ApiCaller.Get(
        `/interview/list?page=${page}&limit=${limit}&type=${type}`,
      );
      if (res.status == 200) {
        yield put(InterviewsAction.getInterviewsListingSuccess(res.data));
        console.log("InterviewsListingSuccess", res.data.data);

        if (cb) {
          cb();
        }
      } else {
        yield put(
          InterviewsAction.getInterviewsListingFailure(res.data.message),
        );
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(InterviewsAction.getInterviewsListingFailure());
      //   Utils.showSnackBar({
      //     message: "Reset password failed",
      //     severity: "error",
      //   });
    }
  }

  static *DeleteInterviews({ id, cb }) {
    try {
      let res = yield ApiCaller.Delete(`/interview/${id}`);
      if (res.status == 200) {
        yield put(InterviewsAction.deleteInterviewsSuccess(res.data));
        Utils.showSnackBar({
          message: res.data.message,
        });
        if (cb) {
          cb();
        }
      } else {
        yield put(InterviewsAction.deleteInterviewsFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(yield put(InterviewsAction.deleteInterviewsFailure()));
    }
  }

  static *GetBackgroundListing({ payload, cb }) {
    try {
      const { offset = 0, limit = 10, type = "user" } = payload;

      const res = yield ApiCaller.Get(
        `/background?offset=${offset}&limit=${limit}&type=${type}`,
      );

      if (res.status === 200) {
        yield put(InterviewsAction.getBackgroundListingSuccess(res.data.data));

        if (cb) cb();
      } else {
        yield put(
          InterviewsAction.getBackgroundListingFailure(res.data.message),
        );
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (error) {
      yield put(InterviewsAction.getBackgroundListingFailure());
    }
  }

  static *AddBackground({ payload, cb }) {
    try {
      // Create FormData for file upload
      const formData = new FormData();
      formData.append("image", payload.image); // File
      formData.append("name", payload.name); // Text
      formData.append("type", payload.type); // Text

      const res = yield ApiCaller.Post("/background", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.status === 200 || res.status === 201) {
        yield put(InterviewsAction.addBackgroundSuccess(res.data.data));
        Utils.showSnackBar({ message: res.data.message });
        if (cb) cb();
      } else {
        yield put(InterviewsAction.addBackgroundFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (error) {
      yield put(InterviewsAction.addBackgroundFailure(error.message));
      Utils.showSnackBar({
        message: "Background upload failed",
        severity: "error",
      });
    }
  }

  static *DeleteBackground({ id, cb }) {
    try {
      const res = yield ApiCaller.Delete(`/background/${id}`);

      if (res.status === 200) {
        yield put(InterviewsAction.deleteBackgroundSuccess(res.data));
        Utils.showSnackBar({ message: res.data.message });
        if (cb) cb();
      } else {
        yield put(InterviewsAction.deleteBackgroundFailure(res.data.message));
        Utils.showSnackBar({ message: res.data.message, severity: "error" });
      }
    } catch (error) {
      yield put(InterviewsAction.deleteBackgroundFailure(error.message));
      Utils.showSnackBar({
        message: "Background deletion failed",
        severity: "error",
      });
    }
  }
}
